/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */

/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */

// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, FileData, prepare } from 'yapi-to-typescript'
// @ts-ignore
// prettier-ignore
import type { RequestConfig, RequestFunctionRestArgs } from 'yapi-to-typescript'
// @ts-ignore
import request from '../request'
// @ts-ignore
import makeRequestHook from '../makeRequestHook'

type UserRequestRestArgs = RequestFunctionRestArgs<typeof request>

// Request: 目前 React Hooks 功能有用到
export type Request<
  TRequestData,
  TRequestConfig extends RequestConfig,
  TRequestResult,
> = (TRequestConfig['requestDataOptional'] extends true
  ? (requestData?: TRequestData, ...args: RequestFunctionRestArgs<typeof request>) => TRequestResult
  : (requestData: TRequestData, ...args: RequestFunctionRestArgs<typeof request>) => TRequestResult) & {
  requestConfig: TRequestConfig
}

const mockUrl_0_0_0_0 = 'http://127.0.0.1:50505/mock/0' as any
const devUrl_0_0_0_0 = '' as any
const prodUrl_0_0_0_0 = '' as any
const dataKey_0_0_0_0 = 'data' as any

/**
 * 接口 退出登录 的 **请求类型**
 *
 * @分类 用户设置
 * @请求头 `GET /manage/user/logout`
 */
export interface GetLogoutRequest {}

/**
 * 接口 退出登录 的 **返回类型**
 *
 * @分类 用户设置
 * @请求头 `GET /manage/user/logout`
 */
export interface GetLogoutResponse {}

/**
 * 接口 退出登录 的 **请求配置的类型**
 *
 * @分类 用户设置
 * @请求头 `GET /manage/user/logout`
 */
type GetLogoutRequestConfig = Readonly<
  RequestConfig<'http://127.0.0.1:50505/mock/0', '', '', '/manage/user/logout', 'data', string, string, true>
>

/**
 * 接口 退出登录 的 **请求配置**
 *
 * @分类 用户设置
 * @请求头 `GET /manage/user/logout`
 */
const getLogoutRequestConfig: GetLogoutRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/manage/user/logout',
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'getLogout',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
}

/**
 * 接口 退出登录 的 **请求函数**
 *
 * @分类 用户设置
 * @请求头 `GET /manage/user/logout`
 */
export const getLogout = /*#__PURE__*/ (requestData?: GetLogoutRequest, ...args: UserRequestRestArgs) => {
  return request<GetLogoutResponse>(prepare(getLogoutRequestConfig, requestData), ...args)
}

getLogout.requestConfig = getLogoutRequestConfig

/**
 * 接口 退出登录 的 **React Hook**
 *
 * @分类 用户设置
 * @请求头 `GET /manage/user/logout`
 */
export const useGetLogout = /*#__PURE__*/ makeRequestHook<
  GetLogoutRequest,
  GetLogoutRequestConfig,
  ReturnType<typeof getLogout>
>(getLogout)

/**
 * 接口 验证手机 的 **请求类型**
 *
 * @分类 用户设置
 * @请求头 `GET /manage/user/verify`
 */
export interface GetVerifyRequest {
  /**
   * 手机号
   */
  mobile: string
  /**
   * 验证码
   */
  code: string
}

/**
 * 接口 验证手机 的 **返回类型**
 *
 * @分类 用户设置
 * @请求头 `GET /manage/user/verify`
 */
export interface GetVerifyResponse {}

/**
 * 接口 验证手机 的 **请求配置的类型**
 *
 * @分类 用户设置
 * @请求头 `GET /manage/user/verify`
 */
type GetVerifyRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/manage/user/verify',
    'data',
    string,
    'mobile' | 'code',
    false
  >
>

/**
 * 接口 验证手机 的 **请求配置**
 *
 * @分类 用户设置
 * @请求头 `GET /manage/user/verify`
 */
const getVerifyRequestConfig: GetVerifyRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/manage/user/verify',
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: ['mobile', 'code'],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'getVerify',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
}

/**
 * 接口 验证手机 的 **请求函数**
 *
 * @分类 用户设置
 * @请求头 `GET /manage/user/verify`
 */
export const getVerify = /*#__PURE__*/ (requestData: GetVerifyRequest, ...args: UserRequestRestArgs) => {
  return request<GetVerifyResponse>(prepare(getVerifyRequestConfig, requestData), ...args)
}

getVerify.requestConfig = getVerifyRequestConfig

/**
 * 接口 验证手机 的 **React Hook**
 *
 * @分类 用户设置
 * @请求头 `GET /manage/user/verify`
 */
export const useGetVerify = /*#__PURE__*/ makeRequestHook<
  GetVerifyRequest,
  GetVerifyRequestConfig,
  ReturnType<typeof getVerify>
>(getVerify)

/**
 * 接口 重置密码短信验证码 的 **请求类型**
 *
 * @分类 用户设置
 * @请求头 `GET /manage/user/sendResetPwdSms`
 */
export interface GetSendResetPwdSmsRequest {
  /**
   * 手机号码
   */
  mobile: string
}

/**
 * 接口 重置密码短信验证码 的 **返回类型**
 *
 * @分类 用户设置
 * @请求头 `GET /manage/user/sendResetPwdSms`
 */
export interface GetSendResetPwdSmsResponse {}

/**
 * 接口 重置密码短信验证码 的 **请求配置的类型**
 *
 * @分类 用户设置
 * @请求头 `GET /manage/user/sendResetPwdSms`
 */
type GetSendResetPwdSmsRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/manage/user/sendResetPwdSms',
    'data',
    string,
    'mobile',
    false
  >
>

/**
 * 接口 重置密码短信验证码 的 **请求配置**
 *
 * @分类 用户设置
 * @请求头 `GET /manage/user/sendResetPwdSms`
 */
const getSendResetPwdSmsRequestConfig: GetSendResetPwdSmsRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/manage/user/sendResetPwdSms',
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: ['mobile'],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'getSendResetPwdSms',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
}

/**
 * 接口 重置密码短信验证码 的 **请求函数**
 *
 * @分类 用户设置
 * @请求头 `GET /manage/user/sendResetPwdSms`
 */
export const getSendResetPwdSms = /*#__PURE__*/ (
  requestData: GetSendResetPwdSmsRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GetSendResetPwdSmsResponse>(prepare(getSendResetPwdSmsRequestConfig, requestData), ...args)
}

getSendResetPwdSms.requestConfig = getSendResetPwdSmsRequestConfig

/**
 * 接口 重置密码短信验证码 的 **React Hook**
 *
 * @分类 用户设置
 * @请求头 `GET /manage/user/sendResetPwdSms`
 */
export const useGetSendResetPwdSms = /*#__PURE__*/ makeRequestHook<
  GetSendResetPwdSmsRequest,
  GetSendResetPwdSmsRequestConfig,
  ReturnType<typeof getSendResetPwdSms>
>(getSendResetPwdSms)

/**
 * 接口 重置密码 的 **请求类型**
 *
 * @分类 用户设置
 * @请求头 `GET /manage/user/resetPassword`
 */
export interface GetResetPasswordRequest {
  /**
   * 手机号
   */
  mobile?: string
  /**
   * 验证码
   */
  code?: string
  /**
   * 密码（MD5密文,小写转大写）
   */
  password?: string
  /**
   * 确认密码（MD5密文，小写转大写）
   */
  rePassword?: string
}

/**
 * 接口 重置密码 的 **返回类型**
 *
 * @分类 用户设置
 * @请求头 `GET /manage/user/resetPassword`
 */
export interface GetResetPasswordResponse {}

/**
 * 接口 重置密码 的 **请求配置的类型**
 *
 * @分类 用户设置
 * @请求头 `GET /manage/user/resetPassword`
 */
type GetResetPasswordRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/manage/user/resetPassword',
    'data',
    string,
    'mobile' | 'code' | 'password' | 'rePassword',
    false
  >
>

/**
 * 接口 重置密码 的 **请求配置**
 *
 * @分类 用户设置
 * @请求头 `GET /manage/user/resetPassword`
 */
const getResetPasswordRequestConfig: GetResetPasswordRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/manage/user/resetPassword',
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: ['mobile', 'code', 'password', 'rePassword'],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'getResetPassword',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
}

/**
 * 接口 重置密码 的 **请求函数**
 *
 * @分类 用户设置
 * @请求头 `GET /manage/user/resetPassword`
 */
export const getResetPassword = /*#__PURE__*/ (requestData: GetResetPasswordRequest, ...args: UserRequestRestArgs) => {
  return request<GetResetPasswordResponse>(prepare(getResetPasswordRequestConfig, requestData), ...args)
}

getResetPassword.requestConfig = getResetPasswordRequestConfig

/**
 * 接口 重置密码 的 **React Hook**
 *
 * @分类 用户设置
 * @请求头 `GET /manage/user/resetPassword`
 */
export const useGetResetPassword = /*#__PURE__*/ makeRequestHook<
  GetResetPasswordRequest,
  GetResetPasswordRequestConfig,
  ReturnType<typeof getResetPassword>
>(getResetPassword)

/**
 * 接口 更新用户自己的信息 的 **请求类型**
 *
 * @分类 用户设置
 * @请求头 `GET /manage/user/updateInfo`
 */
export interface GetUpdateInfoRequest {
  /**
   * 头像链接
   */
  logo?: string
}

/**
 * 接口 更新用户自己的信息 的 **返回类型**
 *
 * @分类 用户设置
 * @请求头 `GET /manage/user/updateInfo`
 */
export interface GetUpdateInfoResponse {
  userId: number
  userName: string
  logo: string
  roleId: number
  roleName: string
  lastLoginTime: string
  suppliers: {
    shopId?: number
    shopName?: string
    shopLogo?: string
    supplierId?: number
    supplierName?: string
    supplierMark?: string
    goodsExemptExamine?: number
    newAuditStatus?: number
    openApi?: number
  }[]
  /**
   * 微笑加密交由前端处理
   */
  mobile: string
}

/**
 * 接口 更新用户自己的信息 的 **请求配置的类型**
 *
 * @分类 用户设置
 * @请求头 `GET /manage/user/updateInfo`
 */
type GetUpdateInfoRequestConfig = Readonly<
  RequestConfig<'http://127.0.0.1:50505/mock/0', '', '', '/manage/user/updateInfo', 'data', string, 'logo', false>
>

/**
 * 接口 更新用户自己的信息 的 **请求配置**
 *
 * @分类 用户设置
 * @请求头 `GET /manage/user/updateInfo`
 */
const getUpdateInfoRequestConfig: GetUpdateInfoRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/manage/user/updateInfo',
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: ['logo'],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'getUpdateInfo',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
}

/**
 * 接口 更新用户自己的信息 的 **请求函数**
 *
 * @分类 用户设置
 * @请求头 `GET /manage/user/updateInfo`
 */
export const getUpdateInfo = /*#__PURE__*/ (requestData: GetUpdateInfoRequest, ...args: UserRequestRestArgs) => {
  return request<GetUpdateInfoResponse>(prepare(getUpdateInfoRequestConfig, requestData), ...args)
}

getUpdateInfo.requestConfig = getUpdateInfoRequestConfig

/**
 * 接口 更新用户自己的信息 的 **React Hook**
 *
 * @分类 用户设置
 * @请求头 `GET /manage/user/updateInfo`
 */
export const useGetUpdateInfo = /*#__PURE__*/ makeRequestHook<
  GetUpdateInfoRequest,
  GetUpdateInfoRequestConfig,
  ReturnType<typeof getUpdateInfo>
>(getUpdateInfo)

const mockUrl_0_0_0_1 = 'http://127.0.0.1:50505/mock/0' as any
const devUrl_0_0_0_1 = '' as any
const prodUrl_0_0_0_1 = '' as any
const dataKey_0_0_0_1 = 'data' as any

/**
 * 接口 增加账号 的 **请求类型**
 *
 * @分类 店铺管理
 * @请求头 `GET /manage/user/add`
 */
export interface GetAddRequest {
  /**
   * 昵称
   */
  username?: string
  /**
   * ERP岗位ID
   */
  erpRoleId?: string
  /**
   * 手机号
   */
  mobile?: string
  /**
   * 密码（MD5密文,小写转大写）
   */
  password?: string
}

/**
 * 接口 增加账号 的 **返回类型**
 *
 * @分类 店铺管理
 * @请求头 `GET /manage/user/add`
 */
export interface GetAddResponse {}

/**
 * 接口 增加账号 的 **请求配置的类型**
 *
 * @分类 店铺管理
 * @请求头 `GET /manage/user/add`
 */
type GetAddRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/manage/user/add',
    'data',
    string,
    'username' | 'erpRoleId' | 'mobile' | 'password',
    false
  >
>

/**
 * 接口 增加账号 的 **请求配置**
 *
 * @分类 店铺管理
 * @请求头 `GET /manage/user/add`
 */
const getAddRequestConfig: GetAddRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_1,
  devUrl: devUrl_0_0_0_1,
  prodUrl: prodUrl_0_0_0_1,
  path: '/manage/user/add',
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_1,
  paramNames: [],
  queryNames: ['username', 'erpRoleId', 'mobile', 'password'],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'getAdd',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
}

/**
 * 接口 增加账号 的 **请求函数**
 *
 * @分类 店铺管理
 * @请求头 `GET /manage/user/add`
 */
export const getAdd = /*#__PURE__*/ (requestData: GetAddRequest, ...args: UserRequestRestArgs) => {
  return request<GetAddResponse>(prepare(getAddRequestConfig, requestData), ...args)
}

getAdd.requestConfig = getAddRequestConfig

/**
 * 接口 增加账号 的 **React Hook**
 *
 * @分类 店铺管理
 * @请求头 `GET /manage/user/add`
 */
export const useGetAdd = /*#__PURE__*/ makeRequestHook<GetAddRequest, GetAddRequestConfig, ReturnType<typeof getAdd>>(
  getAdd,
)

/**
 * 接口 编辑账号 的 **请求类型**
 *
 * @分类 店铺管理
 * @请求头 `GET /manage/user/edit`
 */
export interface GetEditRequest {
  /**
   * 用户id
   */
  id: string
  /**
   * 用户昵称
   */
  username?: string
  /**
   * ERP岗位ID
   */
  erpRoleId?: string
  /**
   * 密码(MD5密文，小写转大写)
   */
  password?: string
}

/**
 * 接口 编辑账号 的 **返回类型**
 *
 * @分类 店铺管理
 * @请求头 `GET /manage/user/edit`
 */
export interface GetEditResponse {}

/**
 * 接口 编辑账号 的 **请求配置的类型**
 *
 * @分类 店铺管理
 * @请求头 `GET /manage/user/edit`
 */
type GetEditRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/manage/user/edit',
    'data',
    string,
    'id' | 'username' | 'erpRoleId' | 'password',
    false
  >
>

/**
 * 接口 编辑账号 的 **请求配置**
 *
 * @分类 店铺管理
 * @请求头 `GET /manage/user/edit`
 */
const getEditRequestConfig: GetEditRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_1,
  devUrl: devUrl_0_0_0_1,
  prodUrl: prodUrl_0_0_0_1,
  path: '/manage/user/edit',
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_1,
  paramNames: [],
  queryNames: ['id', 'username', 'erpRoleId', 'password'],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'getEdit',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
}

/**
 * 接口 编辑账号 的 **请求函数**
 *
 * @分类 店铺管理
 * @请求头 `GET /manage/user/edit`
 */
export const getEdit = /*#__PURE__*/ (requestData: GetEditRequest, ...args: UserRequestRestArgs) => {
  return request<GetEditResponse>(prepare(getEditRequestConfig, requestData), ...args)
}

getEdit.requestConfig = getEditRequestConfig

/**
 * 接口 编辑账号 的 **React Hook**
 *
 * @分类 店铺管理
 * @请求头 `GET /manage/user/edit`
 */
export const useGetEdit = /*#__PURE__*/ makeRequestHook<
  GetEditRequest,
  GetEditRequestConfig,
  ReturnType<typeof getEdit>
>(getEdit)

/**
 * 接口 启用\/禁用账号 的 **请求类型**
 *
 * @分类 店铺管理
 * @请求头 `GET /manage/user/enable`
 */
export interface GetEnableRequest {
  /**
   * 用户ID
   */
  userId?: string
  /**
   * 是否启用
   */
  enable?: string
}

/**
 * 接口 启用\/禁用账号 的 **返回类型**
 *
 * @分类 店铺管理
 * @请求头 `GET /manage/user/enable`
 */
export interface GetEnableResponse {
  isEnabled: boolean
}

/**
 * 接口 启用\/禁用账号 的 **请求配置的类型**
 *
 * @分类 店铺管理
 * @请求头 `GET /manage/user/enable`
 */
type GetEnableRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/manage/user/enable',
    'data',
    string,
    'userId' | 'enable',
    false
  >
>

/**
 * 接口 启用\/禁用账号 的 **请求配置**
 *
 * @分类 店铺管理
 * @请求头 `GET /manage/user/enable`
 */
const getEnableRequestConfig: GetEnableRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_1,
  devUrl: devUrl_0_0_0_1,
  prodUrl: prodUrl_0_0_0_1,
  path: '/manage/user/enable',
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_1,
  paramNames: [],
  queryNames: ['userId', 'enable'],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'getEnable',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
}

/**
 * 接口 启用\/禁用账号 的 **请求函数**
 *
 * @分类 店铺管理
 * @请求头 `GET /manage/user/enable`
 */
export const getEnable = /*#__PURE__*/ (requestData: GetEnableRequest, ...args: UserRequestRestArgs) => {
  return request<GetEnableResponse>(prepare(getEnableRequestConfig, requestData), ...args)
}

getEnable.requestConfig = getEnableRequestConfig

/**
 * 接口 启用\/禁用账号 的 **React Hook**
 *
 * @分类 店铺管理
 * @请求头 `GET /manage/user/enable`
 */
export const useGetEnable = /*#__PURE__*/ makeRequestHook<
  GetEnableRequest,
  GetEnableRequestConfig,
  ReturnType<typeof getEnable>
>(getEnable)

/**
 * 接口  取消关联 的 **请求类型**
 *
 * @分类 店铺管理
 * @请求头 `GET /manage/user/disassociation`
 */
export interface GetDisassociationRequest {
  /**
   * 用户ID
   */
  userId: string
}

/**
 * 接口  取消关联 的 **返回类型**
 *
 * @分类 店铺管理
 * @请求头 `GET /manage/user/disassociation`
 */
export type GetDisassociationResponse = string

/**
 * 接口  取消关联 的 **请求配置的类型**
 *
 * @分类 店铺管理
 * @请求头 `GET /manage/user/disassociation`
 */
type GetDisassociationRequestConfig = Readonly<
  RequestConfig<'http://127.0.0.1:50505/mock/0', '', '', '/manage/user/disassociation', 'data', string, 'userId', false>
>

/**
 * 接口  取消关联 的 **请求配置**
 *
 * @分类 店铺管理
 * @请求头 `GET /manage/user/disassociation`
 */
const getDisassociationRequestConfig: GetDisassociationRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_1,
  devUrl: devUrl_0_0_0_1,
  prodUrl: prodUrl_0_0_0_1,
  path: '/manage/user/disassociation',
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_1,
  paramNames: [],
  queryNames: ['userId'],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'getDisassociation',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
}

/**
 * 接口  取消关联 的 **请求函数**
 *
 * @分类 店铺管理
 * @请求头 `GET /manage/user/disassociation`
 */
export const getDisassociation = /*#__PURE__*/ (
  requestData: GetDisassociationRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GetDisassociationResponse>(prepare(getDisassociationRequestConfig, requestData), ...args)
}

getDisassociation.requestConfig = getDisassociationRequestConfig

/**
 * 接口  取消关联 的 **React Hook**
 *
 * @分类 店铺管理
 * @请求头 `GET /manage/user/disassociation`
 */
export const useGetDisassociation = /*#__PURE__*/ makeRequestHook<
  GetDisassociationRequest,
  GetDisassociationRequestConfig,
  ReturnType<typeof getDisassociation>
>(getDisassociation)

/**
 * 接口 账号编辑与关联店铺 的 **请求类型**
 *
 * @分类 店铺管理
 * @请求头 `GET /manage/user/editAndAssociation`
 */
export interface GetEditAndAssociationRequest {
  /**
   * 昵称
   */
  username?: string
  /**
   * ERP岗位ID
   */
  erpRoleId?: string
  /**
   * 手机号
   */
  mobile?: string
  /**
   * 密码（MD5密文,小写转大写）
   */
  password?: string
}

/**
 * 接口 账号编辑与关联店铺 的 **返回类型**
 *
 * @分类 店铺管理
 * @请求头 `GET /manage/user/editAndAssociation`
 */
export interface GetEditAndAssociationResponse {}

/**
 * 接口 账号编辑与关联店铺 的 **请求配置的类型**
 *
 * @分类 店铺管理
 * @请求头 `GET /manage/user/editAndAssociation`
 */
type GetEditAndAssociationRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/manage/user/editAndAssociation',
    'data',
    string,
    'username' | 'erpRoleId' | 'mobile' | 'password',
    false
  >
>

/**
 * 接口 账号编辑与关联店铺 的 **请求配置**
 *
 * @分类 店铺管理
 * @请求头 `GET /manage/user/editAndAssociation`
 */
const getEditAndAssociationRequestConfig: GetEditAndAssociationRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_1,
  devUrl: devUrl_0_0_0_1,
  prodUrl: prodUrl_0_0_0_1,
  path: '/manage/user/editAndAssociation',
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_1,
  paramNames: [],
  queryNames: ['username', 'erpRoleId', 'mobile', 'password'],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'getEditAndAssociation',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
}

/**
 * 接口 账号编辑与关联店铺 的 **请求函数**
 *
 * @分类 店铺管理
 * @请求头 `GET /manage/user/editAndAssociation`
 */
export const getEditAndAssociation = /*#__PURE__*/ (
  requestData: GetEditAndAssociationRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GetEditAndAssociationResponse>(prepare(getEditAndAssociationRequestConfig, requestData), ...args)
}

getEditAndAssociation.requestConfig = getEditAndAssociationRequestConfig

/**
 * 接口 账号编辑与关联店铺 的 **React Hook**
 *
 * @分类 店铺管理
 * @请求头 `GET /manage/user/editAndAssociation`
 */
export const useGetEditAndAssociation = /*#__PURE__*/ makeRequestHook<
  GetEditAndAssociationRequest,
  GetEditAndAssociationRequestConfig,
  ReturnType<typeof getEditAndAssociation>
>(getEditAndAssociation)

/* prettier-ignore-end */
